import { render, staticRenderFns } from "./ColorItem.vue?vue&type=template&id=620fce80&scoped=true&"
import script from "./ColorItem.vue?vue&type=script&lang=js&"
export * from "./ColorItem.vue?vue&type=script&lang=js&"
import style0 from "./ColorItem.vue?vue&type=style&index=0&id=620fce80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620fce80",
  null
  
)

export default component.exports